import React, { useEffect, useState, useRef, useCallback } from 'react';
import '../styles/profile.css';
import '../styles/landingpage.css';
import { FiSettings } from "react-icons/fi";
import { returnInTZ, todayInTZ } from '../utils/timezone';
import {
  Flex,
  Text,
  Heading,
  Input,
  Button,
  InputGroup,
  Stack,
  StackDivider,
  Select,
  Spinner,
  Box,
  Icon,
  Avatar,
  FormControl,
  FormHelperText,
  Card,
  CardBody,
  Center,
  InputRightElement,
  HStack,
  useColorMode,
  useDisclosure,
  VStack
} from "@chakra-ui/react";
import TradingSpinner from "./TradingSpinner";
import ConfirmDialog from "./common/ConfirmDialog";
import ChangePasswordDialog from "./userprofile/ChangePasswordDialog";
import SettingsDialog from "./userprofile/SettingsDialog";
import PerformanceCardModal from "./userprofile/PerformanceCardModal";
import ProfilePicDialog from "./userprofile/ProfilePicDialog";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom"
import { logout, deleteUser, changePassword, expiredLogout } from '../store/auth/thunks';
import { update, setProfilePicture, toggleFeatureFlags, updatePreferredCurrency, updatePreferredTwoFAMethod, setUsername, checkUsernameAvailability, getAccountValues } from '../store/user/thunks';
import { getTradesStats } from '../store/trades/thunks';
import {
  getPlanAdherence,
  getRiskRewardStats,
  getAccountValueMetrics,
  getJournalStreak,
} from '../store/analytics/thunks';
import { toPng } from 'html-to-image';
import { FaCheck, FaTimes, FaShareAlt } from "react-icons/fa";
import { ExternalLinkIcon } from "@chakra-ui/icons";
import {
  Tooltip,
} from "@chakra-ui/react";
import states from "../data/states";
import currencies from "../data/currencies";
import useToastNotification from "../hooks/useToastNotification";
import useAsyncState from "../hooks/useAsyncState";
import twofamethodsString from '../data/twofamethods'

export default function UserProfile({ user }) {
  const { info } = useAsyncState({
    onError: (info) => showToast(info?.response?.data?.result, { status: "error" }),
  });
  const { preferences } = useSelector((state) => state.user);
  const { profilepic } = useSelector((state) => state.user);
  const hasPreferences = ((preferences && Object.keys(preferences).length > 0) ? (true):(false));
  const hasProfilePicture = ((profilepic && Object.keys(profilepic).length > 0) ? (true):(false));

  // Same pattern as Home/PnlCalendar/Summary: state.ui.loading flips false on
  // first concurrent thunk resolve. Profile content depends on preferences,
  // so gate the spinner on preferencesLoaded too.
  const preferencesLoaded = preferences && Object.keys(preferences).length > 0;
  const { success } = useSelector((state) => state.ui);
  const navigate = useNavigate();
  const showToast = useToastNotification();
  const dispatch = useDispatch();
  const [selectPage, setSelectPage] = useState(true);
  const [updateInfo, selectUpdateInfo] = useState(false);

  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [birthday, setBirthday] = useState("");
  const [email, setEmail] = useState("");
  const [phone_number, setPhoneNumber] = useState("");
  const [street_address, setStreetAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");

  const [changepwdialog, setChangePwAlertDialog] = useState(false);
  const [curr_pass, setCurrPass] = useState("");
  const [new_pass_1, setNewPass1] = useState("");
  const [new_pass_2, setNewPass2] = useState("");

  const [deletealertdialog, setDeleteAlertDialog] = useState(false);

  // Username state
  const [usernameInput, setUsernameInput] = useState("");
  const [usernameCheckTimer, setUsernameCheckTimer] = useState(null);
  const [usernameStatus, setUsernameStatus] = useState(null); // null, 'checking', 'available', 'taken', 'invalid'
  const [usernameError, setUsernameError] = useState("");
  const [usernameSaving, setUsernameSaving] = useState(false);

  // Performance card state
  const [performanceCardModal, setPerformanceCardModal] = useState(false);
  const [shareLinkCopied, setShareLinkCopied] = useState(false);
  const [performanceCardDataUrl, setPerformanceCardDataUrl] = useState(null);
  const [performanceCardLoading, setPerformanceCardLoading] = useState(false);
  const stats = useSelector((state) => state.trades.stats);
  const accountValues = useSelector((state) => state.user.accountValues);
  const planAdherence = useSelector((state) => state.analytics.planAdherence);
  const riskReward = useSelector((state) => state.analytics.riskReward);
  const accountValueMetrics = useSelector((state) => state.analytics.accountValueMetrics);
  const journalStreak = useSelector((state) => state.analytics.journalStreak);
  const cardRef = useRef(null);
  const [renderCard, setRenderCard] = useState(false);

  const [settingsPopUp, setSettingsPopUp] = useState(false);
  // Tracks which settings control is mid-flight so we can disable just that one
  // (single string is fine — toggles are exclusive within the settings dialog).
  const [togglingFlag, setTogglingFlag] = useState(null);

  const [profilePicPopUp, setProfilePicPopUp] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  
  const { onOpen, onClose } = useDisclosure();

  const authLoading = useSelector((state) => state.ui.loading);
  const tradeLoading = useSelector((state) => state.trade.loading);

  const { colorMode } = useColorMode();

  useEffect(() => {
    evaluateSuccess();
  }, [success]); 

  const evaluateSuccess = () => {
    if(success === true && user.result === "User Edited Successfully" && !(info && info.result && info.result === "Password Successfully Changed") && !(profilePicPopUp && profilepic && profilepic.result && profilepic.result === "Profile Picture Uploaded Successfully")){
      if(selectPage === false && updateInfo === true){
        clearFormStates();
        setSelectPage(true);
        selectUpdateInfo(false);
        showToast(user.result);
      }
    }else if(success === true && info && info.result && info.result === "Password Successfully Changed"){
      showToast(info.result);
      setChangePwAlertDialog(false);
      handleLogout();
      onClose();
    }else if (success === true && info && info.result && info.result === "User Successfully Deleted"){
      showToast(info.result);
      dispatch(expiredLogout());    
      setDeleteAlertDialog(false);
      onClose();
    }else if (success === true && profilepic && profilepic.result && profilepic.result === "Profile Picture Uploaded Successfully"){
      if (profilePicPopUp == true){
        showToast(profilepic.result);
        setProfilePicPopUp(false);
      }
    }
  }
  useEffect(() => {
    if (user && user.username) {
      setUsernameInput(user.username);
    }
  }, [user]);

  useEffect(() => {
    const savedUserInfo = window.localStorage.getItem('updateUserInfo');
    if (savedUserInfo) {
      const userInfo = JSON.parse(savedUserInfo);
      setFirstName(userInfo.first_name || "");
      setLastName(userInfo.last_name || "");
      setBirthday(userInfo.birthday || "");
      setEmail(userInfo.email || "");
      setPhoneNumber(userInfo.phone_number || "");
      setStreetAddress(userInfo.street_address || "");
      setCity(userInfo.city || "");
      setState(userInfo.state || "");
      setCountry(userInfo.country || "");
      // Clear the saved info after loading it
      //window.localStorage.removeItem('userInfo');
    }
  }, []); // Empty dependency array means this runs once on mount

  function clearFormStates() {
    setFirstName("");
    setLastName("");
    setBirthday("");
    setEmail("");
    setPhoneNumber("");
    setStreetAddress("");
    setCity("");
    setState("");
    setCountry("");
    window.localStorage.removeItem('updateUserInfo');
  }

  const handleGotoUpdate = (e) => {
    e.preventDefault();
    setSelectPage(false);
    selectUpdateInfo(true);
  };

  const handleChangePassword = (e) => {
    setChangePwAlertDialog(true);
    onOpen();
  };

  const handleConfirmChangePw = async (e) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    await dispatch(
      changePassword({
        curr_pass,
        new_pass_1,
        new_pass_2
      })
    );
  };

  const handleCancelChangePw = (e) => {
    setChangePwAlertDialog(false);
    onClose();
  };

  const handleSettingsPopUp = (e) => {
    setSettingsPopUp(true);
  };

  const handleCloseSettingsPopUp = (e) => {
    setSettingsPopUp(false);
  };

  const handleProfilePicPopUp = (e) => {
    setProfilePicPopUp(true);
    setSelectedFile(null);
  };

  const handleCloseProfilePicPopUp = (e) => {
    setProfilePicPopUp(false);
    setSelectedFile(null);
    setPreviewUrl(null);
  };

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      setSelectedFile(null);
      setPreviewUrl(null);
      alert("Please select an image file.");
    }
  };

  const handleConfirmUpdatePP = async (e) => {
    await dispatch(
      setProfilePicture({
        selectedFile
      })
    );
    setSelectedFile(null);
  };


  const dispatchToggleFlag = async (flag) => {
    setTogglingFlag(flag);
    try {
      await dispatch(toggleFeatureFlags({ flags: [flag] }));
    } finally {
      setTogglingFlag(null);
    }
  };

  const handleToggleAvTracking = () => dispatchToggleFlag("account_value_optin");
  const handleToggleEmailOptin = () => dispatchToggleFlag("email_optin");
  const handleToggle2FA = () => dispatchToggleFlag("2fa_optin");
  const handleTogglePublicProfile = () => dispatchToggleFlag("public_profile_optin");

  // Username handlers
  const validateUsername = (value) => {
    if (!value || value.length === 0) {
      return { valid: false, error: "" };
    }
    if (value.length < 3) {
      return { valid: false, error: "Username must be at least 3 characters" };
    }
    if (value.length > 30) {
      return { valid: false, error: "Username must be 30 characters or less" };
    }
    if (!/^[a-zA-Z0-9_-]+$/.test(value)) {
      return { valid: false, error: "Only letters, numbers, underscores, and hyphens allowed" };
    }
    return { valid: true, error: "" };
  };

  const handleUsernameChange = (e) => {
    const value = e.target.value;
    setUsernameInput(value);
    setShareLinkCopied(false);

    // Clear previous timer
    if (usernameCheckTimer) {
      clearTimeout(usernameCheckTimer);
    }

    const validation = validateUsername(value);
    if (!validation.valid) {
      setUsernameStatus(validation.error ? 'invalid' : null);
      setUsernameError(validation.error);
      return;
    }

    // If it's the same as current username, no need to check
    if (value === user.username) {
      setUsernameStatus(null);
      setUsernameError("");
      return;
    }

    setUsernameStatus('checking');
    setUsernameError("");

    // Debounce the check
    const timer = setTimeout(async () => {
      const result = await dispatch(checkUsernameAvailability({ username: value }));
      if (result.payload && result.payload.available) {
        setUsernameStatus('available');
        setUsernameError("");
      } else {
        setUsernameStatus('taken');
        setUsernameError(result.payload?.result || result.payload?.response?.data?.result || "Username is not available");
      }
    }, 500);
    setUsernameCheckTimer(timer);
  };

  const handleSaveUsername = async () => {
    const validation = validateUsername(usernameInput);
    if (!validation.valid) {
      setUsernameError(validation.error);
      return;
    }
    setUsernameSaving(true);
    const result = await dispatch(setUsername({ username: usernameInput }));
    setUsernameSaving(false);
    if (result.payload && result.payload.username) {
      showToast("Username saved successfully");
      setUsernameStatus(null);
    }
  };

  const handleGeneratePerformanceCard = async () => {
    setPerformanceCardModal(true);
    setPerformanceCardDataUrl(null);
    setPerformanceCardLoading(true);

    // Ensure stats and account values are loaded
    const hasStats = stats && stats.stats && Object.keys(stats.stats).length > 0;
    const hasAv = accountValues && accountValues.accountvalues && accountValues.accountvalues.length > 0;
    const fetches = [];
    if (!hasStats) {
      fetches.push(dispatch(getTradesStats()));
    }
    if (!hasAv) {
      const today = todayInTZ();
      fetches.push(dispatch(getAccountValues({ filters: { date: today } })));
    }
    // TRADE-959: pull the new headline metrics so the Performance Card has them.
    fetches.push(dispatch(getPlanAdherence()));
    fetches.push(dispatch(getRiskRewardStats()));
    fetches.push(dispatch(getAccountValueMetrics({ period: 'all' })));
    fetches.push(dispatch(getJournalStreak()));
    if (fetches.length > 0) {
      await Promise.all(fetches);
    }

    setRenderCard(true);
  };

  const captureCard = useCallback(async () => {
    if (!renderCard || !cardRef.current) return;
    try {
      const dataUrl = await toPng(cardRef.current, {
        pixelRatio: 3,
        cacheBust: true,
        backgroundColor: '#0f172a',
        skipFonts: true,
      });
      setPerformanceCardDataUrl(dataUrl);
    } catch (err) {
      console.error('Failed to capture performance card:', err);
    } finally {
      setPerformanceCardLoading(false);
      setRenderCard(false);
    }
  }, [renderCard]);

  useEffect(() => {
    if (renderCard) {
      const timer = setTimeout(() => captureCard(), 100);
      return () => clearTimeout(timer);
    }
  }, [renderCard, captureCard]);

  const handleCopyShareLink = () => {
    const shareUrl = `${window.location.origin}/u/${user.username}`;
    navigator.clipboard.writeText(shareUrl);
    setShareLinkCopied(true);
    setTimeout(() => setShareLinkCopied(false), 2000);
  };

  const handleToggleTwoFAMethod = async (twofaMethod) => {
    setTogglingFlag("preferred_2fa_method");
    try {
      await dispatch(updatePreferredTwoFAMethod({ preferred_2fa_method: twofaMethod }));
    } finally {
      setTogglingFlag(null);
    }
  }

  const handleToggleCurrencyCode = async (currencyCode) => {
    setTogglingFlag("preferred_currency");
    try {
      await dispatch(updatePreferredCurrency({ preferred_currency: currencyCode }));
    } finally {
      setTogglingFlag(null);
    }
  }

  const handleLogout = async () => {
    setSelectPage(true);
    selectUpdateInfo(false);
    await dispatch(logout());
    navigate("/login");
  };

  const handleDeleteButton = (e) => {
    setDeleteAlertDialog(true);
    onOpen();
  };

  const handleConfirmDelete = async (e) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    await dispatch(deleteUser());
  };

  const handleCancelDelete = (e) => {
    setDeleteAlertDialog(false);
    onClose();
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const updateUserInfo = {
      first_name,
      last_name,
      email,
      phone_number,
      birthday,
      street_address,
      city,
      state,
      country,
    };
    await dispatch(
      update({
        first_name,
        last_name,
        email,
        phone_number,
        birthday,
        street_address,
        city,
        state,
        country
      })
    );
    //clearFormStates();
    window.localStorage.setItem('updateUserInfo', JSON.stringify(updateUserInfo));
  }

  const handleCancel = (e) => {
    e.preventDefault();
    clearFormStates();
    setSelectPage(true);
    selectUpdateInfo(false);
  }

  const handleClear = (e) => {
    e.preventDefault();
    clearFormStates();
  }

    // grabbing current date to set a max to the birthday input
    const currentDate = new Date();
    let [month, day, year] = currentDate.toLocaleDateString().split("/");
    // input max field must have 08 instead of 8
    month = month.length === 2 ? month : "0" + month;
    day = day.length === 2 ? day : "0" + day;
    const maxDate = year + "-" + month + "-" + day;

  return (
    selectPage ? (
        <Flex
          flexDirection="column"
          width="100wh"
          minHeight="100vh"
          backgroundColor={colorMode === 'light' ? "gray.200" : "gray.800"}
          justifyContent="flex-start"
          alignItems="center"
          overflow="auto"
          pt="20px"
          pb="40px"
        >
          <Stack
            className='profilestack'
          >

          <Box minW={{ base: "90%", md: "500px" }} rounded="lg" overflow="hidden" boxShadow="sm">
          {(authLoading || !preferencesLoaded) && !changepwdialog && !deletealertdialog && !settingsPopUp && !profilePicPopUp?
            <Stack
                spacing={4}
                p="1rem"
                bg={colorMode === 'light' ? 'white' : 'gray.700'}
                boxShadow="sm"
              >
              <Center>
                <TradingSpinner size="40px" />
              </Center>
            </Stack>
          :
            <Stack
              spacing={4}
              p="1rem"
              bg={colorMode === 'light' ? 'white' : 'gray.700'}
              boxShadow="sm"
            >
              <Heading fontSize="xl" fontWeight="bold" fontFamily="'Open Sans', sans-serif" color={colorMode === 'light' ? 'gray.700' : 'gray.200'}>Profile Information</Heading>
              <Card>
              <div className='top-right-component'>
                <Icon padding="5px" as={FiSettings} boxSize={8} onClick={handleSettingsPopUp}/>
                <SettingsDialog
                  isOpen={settingsPopUp}
                  onClose={handleCloseSettingsPopUp}
                  user={user}
                  preferences={preferences}
                  hasPreferences={hasPreferences}
                  togglingFlag={togglingFlag}
                  twofamethodsString={twofamethodsString}
                  currencies={currencies}
                  onToggleAvTracking={handleToggleAvTracking}
                  onToggleEmailOptin={handleToggleEmailOptin}
                  onTogglePublicProfile={handleTogglePublicProfile}
                  onToggle2FA={handleToggle2FA}
                  onToggleTwoFAMethod={handleToggleTwoFAMethod}
                  onToggleCurrencyCode={handleToggleCurrencyCode}
                />
              </div>
                <CardBody>
                <Center>
                  <div className="avatar-container" /*onClick={onEditProfilePicture}*/>
                    <Avatar
                      className='avatar'
                      src={hasProfilePicture ? profilepic.profile_picture_url : null}
                      alt="Profile"
                      size='lg'
                      onClick={handleProfilePicPopUp}
                    />
                  <ProfilePicDialog
                    isOpen={profilePicPopUp}
                    onClose={handleCloseProfilePicPopUp}
                    hasProfilePicture={hasProfilePicture}
                    profilePictureUrl={profilepic?.profile_picture_url}
                    selectedFile={selectedFile}
                    previewUrl={previewUrl}
                    isLoading={authLoading}
                    onFileInputChange={handleFileInputChange}
                    onConfirm={handleConfirmUpdatePP}
                  />
                  </div>
                </Center>
                  <Stack divider={<StackDivider />} spacing='3'>
                    {user.first_name !== "" && user.last_name !== "" ? (
                    <Box>
                      <Heading size='xs' textTransform='uppercase'>
                        Full Name
                      </Heading>
                      <Text pt='2' fontSize='sm'>
                        {user.first_name} {user.last_name}
                      </Text>
                    </Box>
                    ) : (
                      null
                    )}
                    <Box>
                      <Heading size='xs' textTransform='uppercase'>
                        Email Address
                      </Heading>
                      <Text pt='2' fontSize='sm'>
                        {user.email}
                      </Text>
                    </Box>
                    {user.phone_number !== "" && user.phone_number !== null ? (
                    <Box>
                      <Heading size='xs' textTransform='uppercase'>
                        Phone Number
                      </Heading>
                      <Text pt='2' fontSize='sm'>
                        {user.phone_number}&nbsp;&nbsp;
                      </Text>
                    </Box>
                    ) : (
                      null
                    )}
                    {user.birthday !== "" && user.birthday !== null ? (
                    <Box>
                      <Heading size='xs' textTransform='uppercase'>
                        Birthday
                      </Heading>
                      <Text pt='2' fontSize='sm'>
                        {user.birthday}&nbsp;&nbsp;
                      </Text>
                    </Box>
                    ) : (
                      null
                    )}
                    {user.street_address !== "" && user.street_address !== null
                      && user.city !== "" && user.city !== null
                      && user.state !== "" && user.state !== null
                      && user.country !== "" && user.country !== null ? (
                    <Box>
                      <Heading size='xs' textTransform='uppercase'>
                        Address
                      </Heading>
                      <Text pt='2' fontSize='sm'>
                        {user.street_address}, {user.city}, {user.state}, {user.country}
                      </Text>
                    </Box>
                    ) : (
                      null  
                    )}
                    <Box>
                      <Heading size='xs' textTransform='uppercase'>
                        Member Since
                      </Heading>
                      <Text pt='2' fontSize='sm'>
                        {returnInTZ(user.created_at)}
                      </Text>
                    </Box>
                    <Box>
                      <Heading size='xs' textTransform='uppercase'>
                        Membership Status
                      </Heading>
                      <Text pt='2' fontSize='sm'>
                        {user.has_paid === 1 ? "Full Membership" : "Free Trial"}
                      </Text>
                    </Box>
                    <Box>
                      <Heading size='xs' textTransform='uppercase'>
                        Public Profile
                      </Heading>
                      <Box pt='2'>
                        <FormControl>
                          <FormHelperText mb={1} ml={0} mt={0}>
                            Username
                          </FormHelperText>
                          <InputGroup size='sm'>
                            <Input
                              value={usernameInput}
                              placeholder="Choose a username"
                              onChange={handleUsernameChange}
                              size='sm'
                            />
                            <InputRightElement>
                              {usernameStatus === 'checking' && (
                                <Spinner size='xs' color='blue.500' />
                              )}
                              {usernameStatus === 'available' && (
                                <Icon as={FaCheck} color='green.500' />
                              )}
                              {(usernameStatus === 'taken' || usernameStatus === 'invalid') && (
                                <Icon as={FaTimes} color='red.500' />
                              )}
                            </InputRightElement>
                          </InputGroup>
                          {usernameError && (
                            <Text color='red.500' fontSize='xs' mt={1}>{usernameError}</Text>
                          )}
                        </FormControl>
                        <HStack mt={2} spacing={2}>
                          <Button
                            size='xs'
                            colorScheme='blue'
                            isLoading={usernameSaving}
                            isDisabled={!usernameInput || usernameStatus === 'taken' || usernameStatus === 'invalid' || usernameStatus === 'checking' || usernameInput === user.username}
                            onClick={handleSaveUsername}
                          >
                            Save Username
                          </Button>
                          {user.username && (
                            <Tooltip label={`${window.location.origin}/u/${user.username}`} placement='top'>
                              <Button
                                size='xs'
                                variant='outline'
                                colorScheme='blue'
                                leftIcon={<ExternalLinkIcon />}
                                onClick={() => window.open(`/u/${user.username}`, '_blank')}
                              >
                                View Profile
                              </Button>
                            </Tooltip>
                          )}
                        </HStack>
                        {user.username && hasPreferences && preferences['public_profile_optin'] === 1 && (
                          <Box mt={3}>
                            <Button
                              size='xs'
                              colorScheme='teal'
                              leftIcon={<Icon as={FaShareAlt} />}
                              onClick={handleGeneratePerformanceCard}
                              isLoading={performanceCardLoading}
                            >
                              Generate Performance Card
                            </Button>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Stack>
                </CardBody>
              </Card>
              <PerformanceCardModal
                isOpen={performanceCardModal}
                onClose={() => setPerformanceCardModal(false)}
                isLoading={performanceCardLoading}
                dataUrl={performanceCardDataUrl}
                shareLinkCopied={shareLinkCopied}
                onCopyShareLink={handleCopyShareLink}
                renderCard={renderCard}
                cardRef={cardRef}
                user={user}
                stats={stats}
                accountValues={accountValues}
                planAdherence={planAdherence}
                riskReward={riskReward}
                accountValueMetrics={accountValueMetrics}
                journalStreak={journalStreak}
              />
              <HStack>
              <Button borderRadius="md"
                type="submit"
                variant="solid"
                colorScheme="blue"
                width="full"
                onClick={handleGotoUpdate}>
                Update Information
              </Button>
              <Tooltip
                label="This account uses Google sign-in and does not have a password. Manage your sign-in via your Google account."
                isDisabled={user.has_password}
                hasArrow
                placement="top"
              >
                <Button borderRadius="md"
                  type="submit"
                  variant="solid"
                  colorScheme="blue"
                  width="full"
                  onClick={handleChangePassword}
                  isDisabled={!user.has_password}>
                  Change Password
                </Button>
              </Tooltip>
              </HStack>
              <Button borderRadius="md"
                type="button"
                variant="outline"
                colorScheme="blue"
                width="full"
                onClick={() => navigate('/myfeedback')}>
                My Feedback
              </Button>
              <Button borderRadius="md"
                type="submit"
                variant="solid"
                colorScheme="blue"
                width="full"
                onClick={handleLogout}>
                Logout
              </Button>
              <Button borderRadius="md"
                type="submit"
                variant="solid"
                colorScheme="red"
                width="full"
                onClick={e => handleDeleteButton(e)}>
                Delete Account
              </Button>
            </Stack>
            }
            <ConfirmDialog
              isOpen={deletealertdialog}
              onClose={handleCancelDelete}
              onConfirm={handleConfirmDelete}
              title="Delete User"
              confirmLabel="Delete"
              confirmColorScheme="red"
              isLoading={authLoading || tradeLoading}
              closeOnOverlayClick={false}
            >
              <strong>Are you sure?</strong> <br /><br />
              <Text as="span" fontWeight="bold">You can't undo this action afterwards.</Text> <br /><br />
              <em>All User data and Trade information will be lost.</em>
            </ConfirmDialog>
            <ChangePasswordDialog
              isOpen={changepwdialog}
              isLoading={authLoading || tradeLoading}
              curr_pass={curr_pass}
              setCurrPass={setCurrPass}
              new_pass_1={new_pass_1}
              setNewPass1={setNewPass1}
              new_pass_2={new_pass_2}
              setNewPass2={setNewPass2}
              onCancel={handleCancelChangePw}
              onConfirm={handleConfirmChangePw}
              onClose={handleChangePassword}
            />
          </Box>
          </Stack>
        </Flex>
    ) : updateInfo ? (
        <Flex
          flexDirection="column"
          width="100wh"
          minHeight="100vh"
          backgroundColor={colorMode === 'light' ? "gray.200" : "gray.800"}
          justifyContent="flex-start"
          alignItems="center"
          overflow="auto"
          pt="20px"
          pb="40px"
        >
          <Stack
            className='profilestack'
          >

          <Box minW={{ base: "90%", md: "468px" }} rounded="lg" overflow="hidden" boxShadow="sm">
          {(authLoading || !preferencesLoaded) && !changepwdialog && !deletealertdialog && !profilePicPopUp?
            <Stack
                spacing={4}
                p="1rem"
                bg={colorMode === 'light' ? 'white' : 'gray.700'}
                boxShadow="sm"
              >
              <Center>
                <TradingSpinner size="40px" />
              </Center>
            </Stack>
          :
          <form>
            <Stack
              spacing={2}
              p="1rem"
              bg={colorMode === 'light' ? 'white' : 'gray.700'}
              boxShadow="sm"
            >
              <Flex justifyContent="space-between" alignItems="center">
                <Heading fontSize="xl" fontWeight="bold" fontFamily="'Open Sans', sans-serif" color={colorMode === 'light' ? 'gray.700' : 'gray.200'}>Update Information</Heading>
                <Button size="sm" variant="ghost" colorScheme="gray" borderRadius="md" onClick={handleClear}>Clear</Button>
              </Flex>
            <Center>
              <VStack>
                <div className="avatar-container">
                  <Avatar
                    className='avatar'
                    src={hasProfilePicture ? profilepic.profile_picture_url : null}
                    alt="Profile"
                    size='lg'
                    onClick={handleProfilePicPopUp}
                  />
                  <ProfilePicDialog
                    isOpen={profilePicPopUp}
                    onClose={handleCloseProfilePicPopUp}
                    hasProfilePicture={hasProfilePicture}
                    profilePictureUrl={profilepic?.profile_picture_url}
                    selectedFile={selectedFile}
                    previewUrl={previewUrl}
                    isLoading={authLoading}
                    onFileInputChange={handleFileInputChange}
                    onConfirm={handleConfirmUpdatePP}
                  />
                </div>
                <Text color="rgb(137, 143, 153)" fontSize="15px">Profile Picture</Text>
              </VStack>
            </Center>
              <Box display="flex">
                <FormControl>
                  <FormHelperText mb={1} ml={1}>
                    First Name
                  </FormHelperText>
                  <Input
                    type="name"
                    value={first_name}
                    placeholder={user.first_name}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </FormControl>
                <FormControl>
                  <FormHelperText mb={1} ml={1}>
                    Last Name
                  </FormHelperText>
                  <Input
                    type="name"
                    value={last_name}
                    placeholder={user.last_name}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </FormControl>
              </Box>
              <FormControl>
                <FormHelperText mb={1} ml={1}>
                  Email
                </FormHelperText>
                <Input value={email} type="name" placeholder={user.email} onChange={(e) => setEmail(e.target.value)} />
              </FormControl>

              <FormControl>
                <FormHelperText mb={1} ml={1}>
                  Birthday
                </FormHelperText>
                <InputGroup>
                  <Input
                    value={birthday} 
                    placeholder={user.birthday}
                    onFocus={(e) => (e.target.type = "date")}
                    onBlur={(e) => (e.target.type = "text")}
                    max={maxDate}
                    min="1900-01-01"
                    onChange={(e) => setBirthday(e.target.value)}
                  />
                </InputGroup>
              </FormControl>

              <FormControl>
                <FormHelperText mb={1} ml={1}>
                  Phone Number (Include +Country Code if Non-US)
                </FormHelperText>
                <Input
                  type="name"
                  value={phone_number}
                  placeholder={user.phone_number}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </FormControl>

              <Box display="flex">
              <FormControl>
                  <FormHelperText mb={1} ml={1}>
                    Street Address
                  </FormHelperText>
                  <Input
                    type="name"
                    value={street_address} 
                    placeholder={user.street_address}
                    onChange={(e) => setStreetAddress(e.target.value)}
                  />
              </FormControl>

              <FormControl>
                  <FormHelperText mb={1} ml={1}>
                    City
                  </FormHelperText>
                  <Input
                    type="name"
                    value={city} 
                    placeholder={user.city}
                    onChange={(e) => setCity(e.target.value)}
                  />
              </FormControl>
              </Box>

              <Box display="flex">
              <FormControl>
                  <FormHelperText mb={1} ml={1}>
                    State
                  </FormHelperText>
                  <Select value={state} onChange={(e) => setState(e.target.value)}>
                    <option value="" disabled selected>{user.state}</option>
                    {states.map((state) => (<option key={state}>{state}</option>))}
                  </Select>
              </FormControl>

              <FormControl>
                  <FormHelperText mb={1} ml={1}>
                    Country
                  </FormHelperText>
                  <Select value={country} onChange={(e) => setCountry(e.target.value)}>
                    <option value="" disabled selected>{user.country}</option>
                    <option value="Afghanistan">Afghanistan</option>
                    <option value="Albania">Albania</option>
                    <option value="Algeria">Algeria</option>
                    <option value="American Samoa">American Samoa</option>
                    <option value="Andorra">Andorra</option>
                    <option value="Angola">Angola</option>
                    <option value="Anguilla">Anguilla</option>
                    <option value="Antartica">Antarctica</option>
                    <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                    <option value="Argentina">Argentina</option>
                    <option value="Armenia">Armenia</option>
                    <option value="Aruba">Aruba</option>
                    <option value="Australia">Australia</option>
                    <option value="Austria">Austria</option>
                    <option value="Azerbaijan">Azerbaijan</option>
                    <option value="Bahamas">Bahamas</option>
                    <option value="Bahrain">Bahrain</option>
                    <option value="Bangladesh">Bangladesh</option>
                    <option value="Barbados">Barbados</option>
                    <option value="Belarus">Belarus</option>
                    <option value="Belgium">Belgium</option>
                    <option value="Belize">Belize</option>
                    <option value="Benin">Benin</option>
                    <option value="Bermuda">Bermuda</option>
                    <option value="Bhutan">Bhutan</option>
                    <option value="Bolivia">Bolivia</option>
                    <option value="Bosnia and Herzegowina">Bosnia and Herzegowina</option>
                    <option value="Botswana">Botswana</option>
                    <option value="Bouvet Island">Bouvet Island</option>
                    <option value="Brazil">Brazil</option>
                    <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                    <option value="Brunei Darussalam">Brunei Darussalam</option>
                    <option value="Bulgaria">Bulgaria</option>
                    <option value="Burkina Faso">Burkina Faso</option>
                    <option value="Burundi">Burundi</option>
                    <option value="Cambodia">Cambodia</option>
                    <option value="Cameroon">Cameroon</option>
                    <option value="Canada">Canada</option>
                    <option value="Cape Verde">Cape Verde</option>
                    <option value="Cayman Islands">Cayman Islands</option>
                    <option value="Central African Republic">Central African Republic</option>
                    <option value="Chad">Chad</option>
                    <option value="Chile">Chile</option>
                    <option value="China">China</option>
                    <option value="Christmas Island">Christmas Island</option>
                    <option value="Cocos Islands">Cocos (Keeling) Islands</option>
                    <option value="Colombia">Colombia</option>
                    <option value="Comoros">Comoros</option>
                    <option value="Congo">Congo</option>
                    <option value="Congo">Congo, the Democratic Republic of the</option>
                    <option value="Cook Islands">Cook Islands</option>
                    <option value="Costa Rica">Costa Rica</option>
                    <option value="Cota D'Ivoire">Cote d'Ivoire</option>
                    <option value="Croatia">Croatia (Hrvatska)</option>
                    <option value="Cuba">Cuba</option>
                    <option value="Cyprus">Cyprus</option>
                    <option value="Czech Republic">Czech Republic</option>
                    <option value="Denmark">Denmark</option>
                    <option value="Djibouti">Djibouti</option>
                    <option value="Dominica">Dominica</option>
                    <option value="Dominican Republic">Dominican Republic</option>
                    <option value="East Timor">East Timor</option>
                    <option value="Ecuador">Ecuador</option>
                    <option value="Egypt">Egypt</option>
                    <option value="El Salvador">El Salvador</option>
                    <option value="Equatorial Guinea">Equatorial Guinea</option>
                    <option value="Eritrea">Eritrea</option>
                    <option value="Estonia">Estonia</option>
                    <option value="Ethiopia">Ethiopia</option>
                    <option value="Falkland Islands">Falkland Islands (Malvinas)</option>
                    <option value="Faroe Islands">Faroe Islands</option>
                    <option value="Fiji">Fiji</option>
                    <option value="Finland">Finland</option>
                    <option value="France">France</option>
                    <option value="France Metropolitan">France, Metropolitan</option>
                    <option value="French Guiana">French Guiana</option>
                    <option value="French Polynesia">French Polynesia</option>
                    <option value="French Southern Territories">French Southern Territories</option>
                    <option value="Gabon">Gabon</option>
                    <option value="Gambia">Gambia</option>
                    <option value="Georgia">Georgia</option>
                    <option value="Germany">Germany</option>
                    <option value="Ghana">Ghana</option>
                    <option value="Gibraltar">Gibraltar</option>
                    <option value="Greece">Greece</option>
                    <option value="Greenland">Greenland</option>
                    <option value="Grenada">Grenada</option>
                    <option value="Guadeloupe">Guadeloupe</option>
                    <option value="Guam">Guam</option>
                    <option value="Guatemala">Guatemala</option>
                    <option value="Guinea">Guinea</option>
                    <option value="Guinea-Bissau">Guinea-Bissau</option>
                    <option value="Guyana">Guyana</option>
                    <option value="Haiti">Haiti</option>
                    <option value="Heard and McDonald Islands">Heard and Mc Donald Islands</option>
                    <option value="Holy See">Holy See (Vatican City State)</option>
                    <option value="Honduras">Honduras</option>
                    <option value="Hong Kong">Hong Kong</option>
                    <option value="Hungary">Hungary</option>
                    <option value="Iceland">Iceland</option>
                    <option value="India">India</option>
                    <option value="Indonesia">Indonesia</option>
                    <option value="Iran">Iran (Islamic Republic of)</option>
                    <option value="Iraq">Iraq</option>
                    <option value="Ireland">Ireland</option>
                    <option value="Israel">Israel</option>
                    <option value="Italy">Italy</option>
                    <option value="Jamaica">Jamaica</option>
                    <option value="Japan">Japan</option>
                    <option value="Jordan">Jordan</option>
                    <option value="Kazakhstan">Kazakhstan</option>
                    <option value="Kenya">Kenya</option>
                    <option value="Kiribati">Kiribati</option>
                    <option value="Democratic People's Republic of Korea">Korea, Democratic People's Republic of</option>
                    <option value="Korea">Korea, Republic of</option>
                    <option value="Kuwait">Kuwait</option>
                    <option value="Kyrgyzstan">Kyrgyzstan</option>
                    <option value="Lao">Lao People's Democratic Republic</option>
                    <option value="Latvia">Latvia</option>
                    <option value="Lebanon">Lebanon</option>
                    <option value="Lesotho">Lesotho</option>
                    <option value="Liberia">Liberia</option>
                    <option value="Libyan Arab Jamahiriya">Libyan Arab Jamahiriya</option>
                    <option value="Liechtenstein">Liechtenstein</option>
                    <option value="Lithuania">Lithuania</option>
                    <option value="Luxembourg">Luxembourg</option>
                    <option value="Macau">Macau</option>
                    <option value="Macedonia">Macedonia, The Former Yugoslav Republic of</option>
                    <option value="Madagascar">Madagascar</option>
                    <option value="Malawi">Malawi</option>
                    <option value="Malaysia">Malaysia</option>
                    <option value="Maldives">Maldives</option>
                    <option value="Mali">Mali</option>
                    <option value="Malta">Malta</option>
                    <option value="Marshall Islands">Marshall Islands</option>
                    <option value="Martinique">Martinique</option>
                    <option value="Mauritania">Mauritania</option>
                    <option value="Mauritius">Mauritius</option>
                    <option value="Mayotte">Mayotte</option>
                    <option value="Mexico">Mexico</option>
                    <option value="Micronesia">Micronesia, Federated States of</option>
                    <option value="Moldova">Moldova, Republic of</option>
                    <option value="Monaco">Monaco</option>
                    <option value="Mongolia">Mongolia</option>
                    <option value="Montserrat">Montserrat</option>
                    <option value="Morocco">Morocco</option>
                    <option value="Mozambique">Mozambique</option>
                    <option value="Myanmar">Myanmar</option>
                    <option value="Namibia">Namibia</option>
                    <option value="Nauru">Nauru</option>
                    <option value="Nepal">Nepal</option>
                    <option value="Netherlands">Netherlands</option>
                    <option value="Netherlands Antilles">Netherlands Antilles</option>
                    <option value="New Caledonia">New Caledonia</option>
                    <option value="New Zealand">New Zealand</option>
                    <option value="Nicaragua">Nicaragua</option>
                    <option value="Niger">Niger</option>
                    <option value="Nigeria">Nigeria</option>
                    <option value="Niue">Niue</option>
                    <option value="Norfolk Island">Norfolk Island</option>
                    <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                    <option value="Norway">Norway</option>
                    <option value="Oman">Oman</option>
                    <option value="Pakistan">Pakistan</option>
                    <option value="Palau">Palau</option>
                    <option value="Panama">Panama</option>
                    <option value="Papua New Guinea">Papua New Guinea</option>
                    <option value="Paraguay">Paraguay</option>
                    <option value="Peru">Peru</option>
                    <option value="Philippines">Philippines</option>
                    <option value="Pitcairn">Pitcairn</option>
                    <option value="Poland">Poland</option>
                    <option value="Portugal">Portugal</option>
                    <option value="Puerto Rico">Puerto Rico</option>
                    <option value="Qatar">Qatar</option>
                    <option value="Reunion">Reunion</option>
                    <option value="Romania">Romania</option>
                    <option value="Russia">Russian Federation</option>
                    <option value="Rwanda">Rwanda</option>
                    <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option> 
                    <option value="Saint LUCIA">Saint LUCIA</option>
                    <option value="Saint Vincent">Saint Vincent and the Grenadines</option>
                    <option value="Samoa">Samoa</option>
                    <option value="San Marino">San Marino</option>
                    <option value="Sao Tome and Principe">Sao Tome and Principe</option> 
                    <option value="Saudi Arabia">Saudi Arabia</option>
                    <option value="Senegal">Senegal</option>
                    <option value="Seychelles">Seychelles</option>
                    <option value="Sierra">Sierra Leone</option>
                    <option value="Singapore">Singapore</option>
                    <option value="Slovakia">Slovakia (Slovak Republic)</option>
                    <option value="Slovenia">Slovenia</option>
                    <option value="Solomon Islands">Solomon Islands</option>
                    <option value="Somalia">Somalia</option>
                    <option value="South Africa">South Africa</option>
                    <option value="South Georgia">South Georgia and the South Sandwich Islands</option>
                    <option value="Span">Spain</option>
                    <option value="SriLanka">Sri Lanka</option>
                    <option value="St. Helena">St. Helena</option>
                    <option value="St. Pierre and Miguelon">St. Pierre and Miquelon</option>
                    <option value="Sudan">Sudan</option>
                    <option value="Suriname">Suriname</option>
                    <option value="Svalbard">Svalbard and Jan Mayen Islands</option>
                    <option value="Swaziland">Swaziland</option>
                    <option value="Sweden">Sweden</option>
                    <option value="Switzerland">Switzerland</option>
                    <option value="Syria">Syrian Arab Republic</option>
                    <option value="Taiwan">Taiwan, Province of China</option>
                    <option value="Tajikistan">Tajikistan</option>
                    <option value="Tanzania">Tanzania, United Republic of</option>
                    <option value="Thailand">Thailand</option>
                    <option value="Togo">Togo</option>
                    <option value="Tokelau">Tokelau</option>
                    <option value="Tonga">Tonga</option>
                    <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                    <option value="Tunisia">Tunisia</option>
                    <option value="Turkey">Turkey</option>
                    <option value="Turkmenistan">Turkmenistan</option>
                    <option value="Turks and Caicos">Turks and Caicos Islands</option>
                    <option value="Tuvalu">Tuvalu</option>
                    <option value="Uganda">Uganda</option>
                    <option value="Ukraine">Ukraine</option>
                    <option value="United Arab Emirates">United Arab Emirates</option>
                    <option value="United Kingdom">United Kingdom</option>
                    <option value="United States">United States</option>
                    <option value="United States Minor Outlying Islands">United States Minor Outlying Islands</option>
                    <option value="Uruguay">Uruguay</option>
                    <option value="Uzbekistan">Uzbekistan</option>
                    <option value="Vanuatu">Vanuatu</option>
                    <option value="Venezuela">Venezuela</option>
                    <option value="Vietnam">Viet Nam</option>
                    <option value="Virgin Islands (British)">Virgin Islands (British)</option>
                    <option value="Virgin Islands (U.S)">Virgin Islands (U.S.)</option>
                    <option value="Wallis and Futana Islands">Wallis and Futuna Islands</option>
                    <option value="Western Sahara">Western Sahara</option>
                    <option value="Yemen">Yemen</option>
                    <option value="Serbia">Serbia</option>
                    <option value="Zambia">Zambia</option>
                    <option value="Zimbabwe">Zimbabwe</option>
                  </Select>
              </FormControl>
              </Box>
              <Button
                marginTop={1}
                borderRadius="md"
                type="submit"
                variant="solid"
                colorScheme="blue"
                width="full"
                onClick={handleUpdate}
              >
                Update
              </Button>
              <Button
                borderRadius="md"
                variant="solid"
                colorScheme="gray"
                width="full"
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </Stack>
          </form>
          }
          </Box>
            
          </Stack>
        </Flex>   
    ) : (
      <Heading textAlign='center' backgroundColor="gray.200"> Error</Heading>
    )
  )
}